import { all, call, put, takeEvery } from 'redux-saga/effects'
import { GET_CURRENT_USER } from '../../Store/Identity/User/UserType';
import { setCurrentUser } from 'Store/Identity/User/UserAction';
import IdentityApiService from './IdentityApiService';

function* getCurrentUserSaga():any {
    try {
        const response = yield call(IdentityApiService.get, `api/Auth/GetUser`);
        yield put(setCurrentUser(response));
    } catch (error) {
        yield put(setCurrentUser({error}));
    }
}

function* getCurrentUserByTimeIntervalSaga():any {
    try {
        yield call(IdentityApiService.get, `api/Auth/PingUser`);
    } catch (error) {
        console.log(error);
    }
}

function* watchOrder() {
    yield takeEvery(GET_CURRENT_USER, getCurrentUserSaga);
    yield takeEvery(GET_CURRENT_USER, getCurrentUserByTimeIntervalSaga);
}

export default function* combinedSaga() {
    yield all([
        watchOrder()
    ])
}
